// Formatar CNPJ (00.000.000/0000-00)
export const formatCNPJ = (value) => {
  const numbers = value.replace(/\D/g, '');

  if (numbers.length <= 2) {
    return numbers;
  } else if (numbers.length <= 5) {
    return `${numbers.slice(0, 2)}.${numbers.slice(2)}`;
  } else if (numbers.length <= 8) {
    return `${numbers.slice(0, 2)}.${numbers.slice(2, 5)}.${numbers.slice(5)}`;
  } else if (numbers.length <= 12) {
    return `${numbers.slice(0, 2)}.${numbers.slice(2, 5)}.${numbers.slice(5, 8)}/${numbers.slice(8)}`;
  } else {
    return `${numbers.slice(0, 2)}.${numbers.slice(2, 5)}.${numbers.slice(5, 8)}/${numbers.slice(8, 12)}-${numbers.slice(12, 14)}`;
  }
};

// Formatar CEP (00000-000)
export const formatCEP = (value) => {
  const numbers = value.replace(/\D/g, '');

  if (numbers.length <= 5) {
    return numbers;
  } else {
    return `${numbers.slice(0, 5)}-${numbers.slice(5, 8)}`;
  }
};

// Validar CNPJ
export const validateCNPJ = (cnpj) => {
  const numbers = cnpj.replace(/\D/g, '');
  return numbers.length === 14;
};

// Validar CEP
export const validateCEP = (cep) => {
  const numbers = cep.replace(/\D/g, '');
  return numbers.length === 8;
};
